import { Pipe, PipeTransform } from '@angular/core';
import {environment} from '../../environments/environment';

@Pipe({
  standalone: true,
  name: 'resellerImage'
})
export class ResellerImagePipe implements PipeTransform {

  transform(imgKey: string): any {
    return `${environment.api.endpoint}assets/img/uploads/global/${imgKey}`;
  }

}
